import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {Client, ClientService} from '@app/admin/client.service';
import {DeleteDialogComponent} from '@app/admin/delete-dialog/delete-dialog.component';
import {TransferDialogComponent} from '@app/admin/transfer-dialog/transfer-dialog.component';
import {PreferencesService} from '@app/preferences/preferences.service';
import {SiteConfigService} from '@app/shared/site-config.service';
import {Observable} from 'rxjs';
import {filter, map, mergeMap, reduce, switchMap, tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'frog-delete-card',
    templateUrl: './delete-card.component.html',
    styleUrls: ['./delete-card.component.scss'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatButton, AsyncPipe],
})
export class DeleteCardComponent implements OnInit {
    public client$: Observable<Client>;
    public hosted = environment.hosted;

    constructor(
        private clientService: ClientService,
        private siteConfigService: SiteConfigService,
        private preferencesService: PreferencesService,
        private matDialog: MatDialog,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.client$ = this.clientService.client;
    }

    confirmDelete(clientId: string): void {
        this.matDialog
            .open(DeleteDialogComponent, {
                data: true,
                width: '60vw',
                height: '420px',
            })
            .afterClosed()
            .pipe(
                filter((result) => Boolean(result)),
                mergeMap(() => this.clientService.delete(clientId)),
                tap(() => this.clientService.getClients()),
                mergeMap(() => this.siteConfigService.get()),
                tap(() => this.preferencesService.getPreferences()),
                reduce((acc, value) => acc),
            )
            .subscribe((siteConfig) => {
                this.router.navigate(['/s', siteConfig.data.primary_stream]);
            });
    }

    confirmCancel(clientId: string): void {
        this.matDialog
            .open(DeleteDialogComponent, {
                data: false,
                width: '60vw',
                height: '420px',
            })
            .afterClosed()
            .pipe(
                filter((result) => Boolean(result)),
                switchMap(() => this.clientService.cancel(clientId)),
            )
            .subscribe((result) => {});
    }

    confirmTransfer(clientId: string): void {
        this.matDialog
            .open(TransferDialogComponent, {
                data: false,
                width: '60vw',
                height: '420px',
            })
            .afterClosed()
            .pipe(
                filter((result) => Boolean(result)),
                map((user) => user.id),
                switchMap((userId) => this.clientService.transfer(clientId, userId)),
            )
            .subscribe((result) => {});
    }
}
